import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { checkUserUsingSocialMedia } from "@/api/openai";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const CheckSocialMedia = () => {
    const [image, setImage] = useState<File | null>(null);
    const [imagePreview, setImagePreview] = useState<string | null>(null);
    const [prompt, setPrompt] = useState("");

    const { mutate, data, isPending } = useMutation({
        mutationFn: async () => {
            if (!image) throw new Error("Please select an image");
            const formData = new FormData();
            formData.append("image", image);
            formData.append("prompt", prompt);
            return await checkUserUsingSocialMedia(formData);
        },
    });

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setImage(file);
            // Create preview URL for image
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result as string);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        mutate();
    };

    return (
        <Card className="w-full max-w-2xl mx-auto">
            <CardHeader>
                <CardTitle>Check Social Media User</CardTitle>
            </CardHeader>
            <CardContent>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="space-y-2">
                        <label className="text-sm font-medium">Select Image</label>
                        <Input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            required
                        />
                        {imagePreview && (
                            <div className="mt-2">
                                <img
                                    src={imagePreview}
                                    alt="Preview"
                                    className="max-w-full h-auto rounded-lg border"
                                    style={{ maxHeight: "300px" }}
                                />
                            </div>
                        )}
                    </div>
                    <div className="space-y-2">
                        <label className="text-sm font-medium">Prompt</label>
                        <Textarea
                            value={prompt}
                            onChange={(e) => setPrompt(e.target.value)}
                            placeholder="Enter your prompt"
                            required
                            className="min-h-[100px]"
                        />
                    </div>
                    <Button type="submit" disabled={isPending}>
                        {isPending ? "Processing..." : "Check"}
                    </Button>
                </form>

                {data && (
                    <div className="mt-4 p-4 border rounded-lg">
                        <h3 className="font-medium mb-2">Result:</h3>
                        <p>Working: {data.working ? "true" : "false"}</p>
                        <p>Confidence: {data.confidence}%</p>
                        <p>Reason: {data.reason}</p>
                    </div>
                )}
            </CardContent>
        </Card>
    );
};

export default CheckSocialMedia; 